// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"BoxScores__wrapper--3ZTec","collapsed":"BoxScores__collapsed--3zsDl","noResults":"BoxScores__noResults--MCQ0D"};


//////////////////
// WEBPACK FOOTER
// ./src/app/views/BoxScores/BoxScores.css
// module id = 49rg
// module chunks = 10